export const EChannels = {
  VOICE: 1,
  WEBCHAT: 2,
  EMAIL: 3,
  FACEBOOK: 4,
  WHATSAPP: 5,
  INSTAGRAM: 6,
  TELEGRAM: 8,
  GOOGLEGBM: 11,
  SMS: 12,
  TEAMS: 15,
  WHATSAPPVOICE: 16,
};
